<template>
  <div class="tabs-wrap">
    <button
      v-for="(r, i) in options"
      :key="i"
      class="tabs-btn"
      :class="value === r.value && 'active-button'"
      @click="$emit('change', r.value)"
    >
      <slot name="btns" :item="r">
        {{ r.label }}
      </slot>
    </button>
  </div>
</template>
<script>
export default {
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    value: [String, Number, Boolean, Object, Symbol],
    options: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {}
  },
  created() {

  },
  methods: {

  }
}
</script>
<style lang="scss" scoped>
  .tabs-wrap {
    height: 33px;
    display: flex;
    border-bottom: 1px solid $color-split;
    .tabs-btn {
      padding: 0 4px;
      @include flex;
      font-weight: 500;
      font-size: 14px;
      line-height: 20px;
      color: $color-gray-3;
      &:not(:first-child) {
        margin-left: 24px;
      }
      &.active-button {
        color: $color-link;
        position: relative;
        &::after {
          content: '';
          position: absolute;
          bottom: -1px;
          left: 0;
          right: 0;
          height: 2px;
          background: $color-link;
        }
      }
    }
  }
</style>
